var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('notifications',{staticClass:"main-notification",attrs:{"group":"foo","position":"top center","width":"100%","classes":"custom-notify"}}),_c('keep-alive',{attrs:{"include":_vm.keepAlive}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }